<template>
  <ErrorPage>
    <div class="noteText">
      好遗憾，不满足活动参与条件，本活动仅限下单成功的老用户参与。
    </div>
  </ErrorPage>
</template>

<script>
import ErrorPage from '@/components/templates/common/ErrorPage';

export default {
  components: { ErrorPage }
};
</script>

<style lang="less" scoped>
.noteText {
  text-align: center;
  width: 500px;
}
</style>
